export const types = [
    "none",
    "number",
    "text",
    "select_single",
    "select_multi",
    "boolean",
    "risk_assessment"
]
